<template>
  <v-container pa-1 style="position: absolute">
    <v-layout v-if="genderIconPossible" :class="alignClass" align-center>
      <v-layout justify-center align-center column mx-1 class="articles">
        <v-img contain width="45" height="45" alt="" :src="genderIcon"></v-img>
        <span :class="'activity-phrase ' + $store.state.phraseClass" dir="auto">
          {{ $store.state.tr['Gender' + subtitle.gender] }}
        </span>
      </v-layout>
      <v-layout
        v-show="subtitle.definite && subtitle.definite !== '' && subtitle.definite !== 'N/A'"
        justify-center align-center column mx-1 class="articles"
      >
        <v-img
          contain
          width="45"
          height="45"
          alt=""
          :src="genderIconBack"
        >
          <v-container pa-0 fill-height>
            <v-layout justify-center align-center fill-height>
              <span class="body-2 white--text">{{ subtitle.definite }}</span>
            </v-layout>
          </v-container>
        </v-img>
        <span :class="'activity-phrase ' + $store.state.phraseClass" dir="auto">
          {{ $store.state.tr.ArticleDefinite }}
        </span>
      </v-layout>
      <v-layout
        v-if="subtitle.indefinite && subtitle.indefinite !== '' && subtitle.indefinite !== 'N/A'"
        justify-center align-center column mx-1 class="articles"
      >
        <v-img
          contain
          width="45"
          height="45"
          alt=""
          :src="genderIconBack"
        >
          <v-container pa-0 fill-height>
            <v-layout justify-center align-center fill-height>
              <span class="body-2 white--text">{{ subtitle.indefinite }}</span>
            </v-layout>
          </v-container>
        </v-img>
        <span :class="'activity-phrase ' + $store.state.phraseClass" dir="auto">
          {{ $store.state.tr.ArticleIndefinite }}
        </span>
      </v-layout>
      <v-layout
        v-if="subtitle.partitive && subtitle.partitive !== '' && subtitle.partitive !== 'N/A'"
        justify-center align-center column mx-1 class="articles"
      >
        <v-img
          contain
          width="45"
          height="45"
          alt=""
          :src="genderIconBack"
        >
          <v-container pa-0 fill-height>
            <v-layout justify-center align-center fill-height>
              <span class="body-2 white--text">{{ subtitle.partitive }}</span>
            </v-layout>
          </v-container>
        </v-img>
        <span :class="'activity-phrase ' + $store.state.phraseClass" dir="auto">
          {{ $store.state.tr.ArticlePartitive }}
        </span>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    subtitle: Object,
    alignClass: String,
  },
  computed: {
    genderIconPossible() {
      if (this.subtitle && this.subtitle.id && this.subtitle.gender) {
        const phraseId = parseInt(this.subtitle.id, 10);
        if (phraseId >= 1 && phraseId <= 1977) {
          return this.subtitle.gender;
        }
        return false;
      }
      return false;
    },
    genderIcon() {
      if (this.genderIconPossible) {
        return `img/gender/${this.subtitle.gender}.png`;
      }
      return '';
    },
    genderIconBack() {
      if (this.genderIconPossible) {
        return `img/gender/${this.subtitle.gender}b.png`;
      }
      return '';
    },
  },
};
</script>

<style>
  .activity-phrase {
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
    width: 100%;
  }

  .articles {
    max-width: 90px;
  }
</style>
